import { useEffect, useState } from 'react';
import AssessmentFilters from './AssessmentFilters';
import { DataProvider } from '../../DataContext';
import AssignmentTable from '../../components/AssignmentTable';
import { useGetAssessmentsMutation, useGetGradeAssessmentsCountMutation, useHideAssessmentsMutation } from '../../../../features/authentication/assessmentApiSlice';
import { useAssessmentContext } from './AssessmentContext';
import { NavLink, useNavigate } from 'react-router-dom';
import { faEllipsis, faEye, faEyeSlash, faFileArrowUp, faGear, faLink, faPrint, faSitemap, faUserGraduate } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Dropdown from 'react-bootstrap/Dropdown';
import NoAssignment from '../../../../assets/images/NoAssignment.png';
import { useUpdateAssessmentFiltersMutation } from '../../../../features/authentication/persistApiSlice';
import TableSkeleton from '../../../../components/SkeletonLoader/TableSkeleton';
import SkeletonGrid from '../../../../components/SkeletonLoader/SkeletonGrid';
import AssessmentAssignModal from '../../components/assessmentFloatingMenu/AssessmentAssignModal';
import AssignmentLinksModal from '../../../../components/AssignmentLinksModal/index';
import { faAward, faKey } from '@fortawesome/free-solid-svg-icons';
import { useAssignmentContext } from '../../context';
import { createPortal } from 'react-dom';
import CreateAssessmentLinkModal from '../../components/assessmentFloatingMenu/CreateAssessmentLinkModal';
import AssignSettingsPopout from '../../components/assessmentFloatingMenu/AssignSettingsPopout';
import OptionTileModal from '../AssignmentsAndActivities/Components/modals/OptionTileModal';
import CustomToast from '../../../../components/Toast';
import { useExportXmlAssignmentsMutation } from '../../../../features/authentication/assignApiSlice';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import ActivityTypes from '../../../../enums/activityTypes';

const Index = () => {
  const limit = 30;
  const [isLoading, setIsLoading] = useState(false);
  const [skipValue, setSkipValue] = useState(0);
  const [assessmentData, setAssessmentData] = useState([]);
  const [total, setTotal] = useState(0);
  const [assignmentSortValue, setAssignmentSortValue] = useState(null);
  const [initial, setInitial] = useState(true);
  const [isOpenViewAssessmentLinks, setIsOpenViewAssessmentLinks] = useState(false);
  const [isOpenCreateLinkModal, setIsOpenCreateLinkModal] = useState(false);
  const [gradeAssessmentsCount, setGradeAssessmentsCount] = useState(0);
  const [getGradeAssessmentsCount] = useGetGradeAssessmentsCountMutation();
  const [getAllAssessments] = useGetAssessmentsMutation();
  const [updateAssessmentFilters] = useUpdateAssessmentFiltersMutation();
  const [isOpenAssignToStudentsModal, setIsOpenAssignToStudentsModal] = useState(false);
  const [assessmentSelected, setAssessmentSelected] = useState(null);
  const [isOpenSettingsPopout, setIsOpenSettingsPopout] = useState(false);
  const [isOpenPrintingOptionsModal, setIsOpenPrintingOptionsModal] = useState(false);
  const [navigation, setNavigation] = useState('');
  const [isOpenHideConfirmationModal, setIsOpenHideConfirmationModal] = useState(false);
  const [hideAssessments] = useHideAssessmentsMutation();
  const [exportAssessments] = useExportXmlAssignmentsMutation();

  const {
    filters,
    setFilters,
    searchText,
    isSearch,
    setIsSearch,
    isAssessmentAvailable,
    selectedAssesmentStatus,
    selectedCourseId,
    refreshAssessments,
    setSelectedAssessments
  } = useAssessmentContext();

  const {
    setAssignmentId,
    setAssignmentName,
    setAssignmentAssignedViaDetails,
    setAssignedStatus
  } = useAssignmentContext();

  const megaDropdown = [
    {
      id: 1,
      name: 'Create Assessment Link',
      icon: <FontAwesomeIcon icon={faLink} />,
      handleClick: () => setIsOpenCreateLinkModal(true)
    },
    {
      id: 2,
      name: 'View Assessment Changes',
      icon: <FontAwesomeIcon icon={faSitemap} />,
      link: `manage_assign/reports/assignment_changes_report/${ActivityTypes.Assessment}`
    },
    {
      id: 3,
      name: 'Assessment Settings',
      icon: <FontAwesomeIcon icon={faGear} />,
      handleClick: () => setIsOpenSettingsPopout(true)
    },
    {
      id: 4,
      name: 'Print Assessment',
      icon: <FontAwesomeIcon icon={faPrint} />,
      handleClick: () => handlePrintOnClick()
    },
    {
      id: 5,
      name: 'Hide',
      icon: <FontAwesomeIcon icon={faEyeSlash} />,
      handleClick: () => handleHideAssessments()
    },
    {
      id: 6,
      name: 'Export',
      icon: <FontAwesomeIcon icon={faFileArrowUp} />,
      handleClick: () => handleExportAssessment()
    }
  ];

  const printingOptions = [
    {
      id: 'standardPrinting',
      icon: <FontAwesomeIcon icon={faPrint} className="printing-icon" />,
      label: 'Standard Assessment Printing',
      isActive: true
    },
    {
      id: 'answerKey',
      icon: <FontAwesomeIcon icon={faKey} className="printing-icon" />,
      label: 'Answer Key'
    }
  ];
  const [printOptions, setPrintOptions] = useState(printingOptions);
  const navigate = useNavigate();

  useEffect(() => {
    if ((assignmentSortValue || isSearch || refreshAssessments) && !initial) {
      setAssessmentData([]);
      setSkipValue(0);
      loadInitialAssessmentData();
      setSelectedAssessments([]);
      updateAssessmentFiltersAsync();
      setFilters(prevFilters => ({ ...prevFilters, courseId: selectedCourseId }));
    }
  }, [isSearch, assignmentSortValue, refreshAssessments]);

  useEffect(() => {
    if (filters && initial) {
      loadInitialAssessmentData();
      getGradeAssessmentsCountAsync();
      setInitial(false);
      setSelectedAssessments([]);
    }
  }, [filters]);

  const getGradeAssessmentsCountAsync = async () =>{
    const count = await getGradeAssessmentsCount().unwrap();
    setGradeAssessmentsCount(count);
  };

  const updateAssessmentFiltersAsync = async () => {
    const options = {
      assessmentStatus: selectedAssesmentStatus.length == 0 ? [] : selectedAssesmentStatus,
      courseId: selectedCourseId,
      sortColumn: filters.sortColumn,
      sortDirection: filters.sortDirection
    };
    await updateAssessmentFilters(options);
  };

  const loadInitialAssessmentData = async () => {
    setIsLoading(true);
    const { total, data } = await getAllAssessmentsAsync(0, 30);
    distinctObjects(data);
    setTotal(total);
    setIsLoading(false);
  };

  const nextCallback = async (newOffset) => {
    setIsLoading(true);
    setSkipValue(newOffset);
    const { total, data } = await getAllAssessmentsAsync(newOffset, limit);
    let newItems = [...assessmentData, ...data];
    distinctObjects(newItems);
    setTotal(total);
    setIsLoading(false);
  };

  const distinctObjects = (data) => {
    var distinctData = Array.from(
      data.reduce((map, obj) => map.set(obj.assignmentId, obj), new Map()).values()
    );
    setAssessmentData(distinctData);
  };

  const getAllAssessmentsAsync = async (skip, take) => {
    try {
      const assessmentStatus = initial ? filters.assessmentStatus : selectedAssesmentStatus.length == 0 ? [] : selectedAssesmentStatus;
      const params = new URLSearchParams();
      if (searchText.length > 0)
        params.append('searchText', searchText);
      assessmentStatus.forEach(item => params.append('assessmentStatus', item));
      params.append('courseId', selectedCourseId);
      params.append('sortColumn', filters.sortColumn);
      params.append('sortDirection', filters.sortDirection);
      const options = {
        skip: skip,
        take: take,
        params: params.toString()
      };

      setIsSearch(false);
      return await getAllAssessments(options).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelect = (e) => {
    const { name, checked } = e.target;
    const id = parseInt(name);
    let updatedAssessments = assessmentData.map((item) =>
      item.assignmentId === id ? { ...item, isChecked: checked } : item
    );
    setAssessmentData(updatedAssessments);
    setSelectedAssessments(updatedAssessments.filter(x => x.isChecked));
  };

  const handleDropdownOpen = (item) => {
    setAssessmentSelected(item);
  };

  const handleMoreSelect = (eventKey,item) => {
    var selectedAction = megaDropdown.find(x => x.id == eventKey);
    if(selectedAction.link) 
    {
      navigate(`/assignments/${item.assignmentId}/${selectedAction.link}`, {
        state: {
          assignmentName: item.assignmentName,
          assignmentId: item.assignmentId
        }
      });
    }else
    {
      selectedAction.handleClick();
    }
  };

  const generateMoreOptions = (item, index) => {
    return (
      <div className="action-btns d-flex justify-content-end gap-2">
        <NavLink
          onClick={() => {
            setAssignmentId(item.assignmentId);
            setAssignmentName(item.assignmentName);
            setAssignmentAssignedViaDetails({ id: null });
            setAssignedStatus(item.assignedStatus);
          }}
          end
          to={`/assignments/${item.assignmentId}/${ActivityTypes.Assessment}/manage_assign`}>
          <ReactTooltip
            id={`manage-${index}`}
            place="top"
            content="View/Manage Assessment"
            className="list-tooltip z-index10"
          />
          <button data-tooltip-id={`manage-${index}`}>
            <FontAwesomeIcon icon={faEye} />
          </button>
        </NavLink>
        <ReactTooltip
          id={`assign-${index}`}
          place="top"
          content="Assign To Students"
          className="list-tooltip z-index10"
        />
        <button
          onClick={() => handleAssignToStudents(item)}
          data-tooltip-id={`assign-${index}`}>
          <FontAwesomeIcon icon={faUserGraduate} />
        </button>
        <div className="position-relative">
          <ReactTooltip
            id={`moreactions-${index}`}
            place="top"
            content="More Actions"
            className="list-tooltip z-index10"
          />
          <Dropdown
            data-tooltip-id={`moreactions-${index}`}
            onToggle={(isOpen) => {
              if (isOpen) {
                handleDropdownOpen(item);
              }
            }}
            onSelect={(eventKey) => handleMoreSelect(eventKey, item)}
          >
            <Dropdown.Toggle>
              <FontAwesomeIcon icon={faEllipsis} />
            </Dropdown.Toggle>
            {createPortal(
              <Dropdown.Menu className='more-dropdown assessment-more px-3' flip>
                {megaDropdown.map((val, arrayKey) => {
                  return (
                    <Dropdown.Item
                      key={`drop-${arrayKey}`}
                      eventKey={val.id}
                      className='py-2 d-flex align-items-center padding-left-0'>
                      <div className='dropdown-item-div d-flex flex-row col-12'>
                        <div className='col-2'>{val.icon}</div>
                        <div className='col-10'>{val.name}</div>
                      </div>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>,
              document.body
            )}
          </Dropdown>
        </div>
      </div>
    );
  };

  const handleAssignToStudents = (assessment) => {
    setAssessmentSelected(assessment);
    setIsOpenAssignToStudentsModal(true);
  };

  const handlePrintOnClick = () => {
    setIsOpenPrintingOptionsModal(!isOpenPrintingOptionsModal);
    setNavigation(`/assignments/${assessmentSelected.assignmentId}/standardPrinting/true`);
    setPrintOptions(printingOptions);
  };

  const handlePrintingOptions = (e) => {
    const id = e.currentTarget.id;
    const option = printOptions.map((item) =>
      item.id === id ? { ...item, isActive: true } : { ...item, isActive: false }
    );

    if (id === 'standardPrinting') {
      const url = `/assignments/${assessmentSelected.assignmentId}/standardPrinting/true`;
      setNavigation(url);
    } else {
      const url = `/assignments/${assessmentSelected.assignmentId}/answerKey/true`;
      setNavigation(url);
    }
    setPrintOptions(option);
  };

  const handlePrintOptionNavigation = () => {
    navigate(navigation, { state: { assignmentId: assessmentSelected.assignmentId, assignmentName: assessmentSelected.assignmentName } });
  };

  const handleHideAssessments = async () => {
    setIsOpenHideConfirmationModal(true);
  };

  const hideSelectedAssessments = async () => {
    try {
      const options = {
        assessmentIds: [assessmentSelected.assignmentId]
      };
  
      var response = await hideAssessments(options);
      if (response.error) {
        if (response.error.data.errors)
          CustomToast(response.error.data.errors.AssessmentIds, 'error');
        else
          CustomToast(response.error.data.error, 'error');
      } else {
        setSelectedAssessments([]);
        setIsSearch(true);
        CustomToast('Assessment Hidden Successfully!', 'success');
      }
      setIsOpenHideConfirmationModal(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleExportAssessment = async () => {
    try {
      const options = [assessmentSelected.assignmentId];
      await exportAssessments(options).unwrap();
    } catch (error) {
      if (error.data) {
        const XMLData = error.data;
        const blob = new Blob([XMLData], { type: 'text/xml' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const fileName = 'CastleXMLAssessments.xml';
        link.download = fileName;
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);
      }
    }
  };

  return (
    <>
      {isAssessmentAvailable ? (
        <>
          <DataProvider loadFolders={false} loadAssignedVia={false}>
            <AssessmentFilters />
          </DataProvider>
          {filters ? (
            <>
              <div className='d-flex justify-content-between mt-5'>
                <h3 className="primary-title">
                  Current Assessments
                  {assessmentData.length > 0 && (
                    <small className="opacity-50"> ({total})</small>
                  )}
                </h3>
                <div>
                  <div className='d-flex gap-3'>
                    <button
                      onClick={() => setIsOpenViewAssessmentLinks(true)}
                      className="btn-link primary-link">
                      <FontAwesomeIcon icon={faLink} /> View Assessment Links
                    </button>
                    {gradeAssessmentsCount > 0 &&
                     <button
                       onClick={()=>navigate('grade_assessments')}
                       className="btn-link primary-link">
                       <FontAwesomeIcon icon={faAward} /> Grade Assessments<span className ="badge-number mx-2 fw-semibold">{gradeAssessmentsCount}</span>
                     </button>
                    }
                  </div>
                </div>
              </div>
              <div className="custom-table table-responsive mt-2">
                <AssignmentTable
                  isAssignment={false}
                  data={assessmentData}
                  nextCallback={nextCallback}
                  skipValue={skipValue}
                  limit={limit}
                  totalCount={total}
                  setAssignmentSortValue={setAssignmentSortValue}
                  filters={filters}
                  setFilters={setFilters}
                  courseId={filters.courseId}
                  moreOption={generateMoreOptions}
                  handleSelect={handleSelect}
                  isLoading={isLoading}
                />
              </div>

              {isOpenAssignToStudentsModal &&
                <AssessmentAssignModal
                  isOpen={isOpenAssignToStudentsModal}
                  onClose={() => setIsOpenAssignToStudentsModal(false)}
                  selectedAssessments={[assessmentSelected]}
                />
              }

              {isOpenViewAssessmentLinks &&
                <AssignmentLinksModal
                  showAssignmentLinksModal={isOpenViewAssessmentLinks}
                  setShowAssignmentLinksModal={setIsOpenViewAssessmentLinks}
                  showAssignedViaFilter={false}
                  isAssessment={true}
                />
              }

              {isOpenCreateLinkModal &&
                <CreateAssessmentLinkModal
                  isOpen={isOpenCreateLinkModal}
                  onClose={()=>setIsOpenCreateLinkModal(false)}
                  selectedAssessments={[assessmentSelected]}
                />
              }

              {isOpenSettingsPopout &&
                      <AssignSettingsPopout
                        isOpen={isOpenSettingsPopout}
                        onClose={()=>setIsOpenSettingsPopout(false)}
                        selectedAssessments={[assessmentSelected]}
                      />
              }

              {isOpenPrintingOptionsModal &&
                      <OptionTileModal
                        isOpen={isOpenPrintingOptionsModal}
                        onClose={() => setIsOpenPrintingOptionsModal(false)}
                        title={'Select Print Option'}
                        options={printOptions}
                        handleOptionClick={handlePrintingOptions}
                        saveLabel={'Continue'}
                        handleSaveClick={handlePrintOptionNavigation}
                      />
              }

              {isOpenHideConfirmationModal && 
                  <ConfirmationModal
                    isOpen={isOpenHideConfirmationModal}
                    onClose={() => setIsOpenHideConfirmationModal(false)}
                    onSave={() => hideSelectedAssessments()}
                    contentWidth={'35%'}
                    buttonPosition={'center'}
                    titleName={'Hide Assessment'}
                    content={'Are you sure that you want to hide this Assessment?'}
                    cancelButton={'No'}
                    confirmButton={'Yes'}
                  />
              }
            </>) : (
            <>
              <SkeletonGrid
                rowCount={1}
                colCount={1}
                className='p-2 mt-5' />
              <div className='mt-4'>
                <TableSkeleton
                  rowCount={6}
                  colCount={5}
                  skeletonClass='p-1' />
              </div>
            </>
          )}
        </>
      ) : (<div className="no-assignments-card my-4">
        <div className="text-center mb-5">
          <img src={NoAssignment} className="my-4" />
          <p className="mb-4">
            The Assessment list is currently empty. You are unable to assign an assessment at this time.
          </p>
        </div>
      </div>)}
    </>
  );
};

export default Index;
